<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
    <v-container fluid full-height grid-list-md>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Currency Name"
                  v-model="currency.name"
                  :rules="[ !!currency.name || 'Currency Name is required']"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Code"
                  v-model="currency.code"
                  :rules="[ !!currency.code || 'Code is required']"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="currency.description"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="currency.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="currency.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="currency.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="currency.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="currency.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="currency.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12 v-if="currency.id">
                <v-switch
                  :label="'Default'"
                  :value="isDefaultFlag"
                  v-model="isDefaultFlag"
                  readonly
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn type="submit" color="primary" :loading="saveLoading" :disabled="!valid">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { currencyService } from "../../services/currency-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { Currency } from "../../models/model";
import { commonService } from "../../services/common-service";

export default {
  name: "CurrencyDetail",
  components: { VSwitch },
  data: () => ({
    breadcrumbs: [
      {
        text: "Currency",
        disabled: false,
        to: "currencies"
      },
      {
        text: "Currency Detail",
        disabled: true
      }
    ],
    updatedDate: "",
    createdDate: "",
    currency: new Currency(),
    oldCurrency: {},
    statusFlag: true,
    isDefaultFlag: false,
    saveLoading: false,
    responseError: "",
    valid: true
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new Currency
    } else {
      this.getCurrencyDetail(id);
    }
  },

  methods: {
    getCurrencyDetail(id) {
      currencyService
        .getCurrencyDetail(id)
        .then(res => {
          this.currency = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.currency.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.currency.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );

          this.oldCurrency = Object.assign({}, res.data);
          this.statusFlag = this.currency.status == "ACTIVE" ? true : false;
          this.isDefaultFlag = this.currency.defaultCurrency;
          console.log(this.currency.defaultCurrency);
        })
        .catch(err => {
          console.log(err);
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.currency.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        currencyService
          .saveCurrency(this.currency)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.currency.id) {
        this.currency = new Currency();
      } else {
        this.statusFlag = this.oldCurrency.status == "ACTIVE" ? true : false;
        this.isDefaultFlag = this.oldCurrency.defaultCurrency;
        this.currency = Object.assign({}, this.oldCurrency);
      }
      this.responseError = "";
    },

    goBack() {
      this.$router.push("/currencies");
    }
  }
};
</script>

<style scoped>
</style>